// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upskld_student_banner_pg_wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-image: linear-gradient(to right, rgb(252, 211, 252), rgb(241, 202, 253));
  box-sizing: border-box;
}

.upskld_student_banner_pg_gif {
  width: 70%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

/* Large Desktop / Large Monitors - 1440px+ */
@media (min-width: 1440px) {
  .upskld_student_banner_pg_gif {
    width: 60%;
  }
}

/* Laptop / Small Desktop - 1024px to 1439px */
@media (max-width: 1439px) {
  .upskld_student_banner_pg_gif {
    width: 68%;
  }
}

/* iPad Pro / Large Tablets (landscape) - 1024px */
@media (max-width: 1024px) {
  .upskld_student_banner_pg_wrapper {
    height: 70vh;
  }

  .upskld_student_banner_pg_gif {
    width: 80%;
  }
}

/* iPad / Android Tablets (portrait & landscape) - 768px to 1023px */
@media (max-width: 768px) {
  .upskld_student_banner_pg_wrapper {
    height: 60vh;
  }

  .upskld_student_banner_pg_gif {
    width: 90%;
  }
}

/* Large Phones / Small Tablets (landscape phones) - 600px to 767px */
@media (max-width: 600px) {
  .upskld_student_banner_pg_wrapper {
    height: 50vh;
  }

  .upskld_student_banner_pg_gif {
    width: 100%;
  }
}

/* Mobile responsive - iPhone Pro Max, Android large - 480px */
@media (max-width: 480px) {
  .upskld_student_banner_pg_wrapper {
    height: 42vh;
  }

  .upskld_student_banner_pg_gif {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
}

/* Standard Phones - iPhone 12/13/14, Android mid - 390px to 479px */
@media (max-width: 390px) {
  .upskld_student_banner_pg_wrapper {
    height: 45vh;
  }
}

/* Small Phones - iPhone SE, older Android - 360px */
@media (max-width: 360px) {
  .upskld_student_banner_pg_wrapper {
    height: 50vh;
  }
}

/* Extra Small Phones - 320px (iPhone 5/SE 1st gen) */
@media (max-width: 320px) {
  .upskld_student_banner_pg_wrapper {
    height: 55vh;
  }
}

/* Landscape orientation - phones/tablets rotated */
@media (max-height: 480px) and (orientation: landscape) {
  .upskld_student_banner_pg_wrapper {
    height: 100vh;
  }

  .upskld_student_banner_pg_gif {
    width: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/STUDENTPLATFORM/StudentBanner/StudentBanner.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mFAAmF;EACnF,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU;EACZ;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;EACZ;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,YAAY;EACd;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,YAAY;EACd;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,YAAY;EACd;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".upskld_student_banner_pg_wrapper {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  background-image: linear-gradient(to right, rgb(252, 211, 252), rgb(241, 202, 253));\n  box-sizing: border-box;\n}\n\n.upskld_student_banner_pg_gif {\n  width: 70%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n/* Large Desktop / Large Monitors - 1440px+ */\n@media (min-width: 1440px) {\n  .upskld_student_banner_pg_gif {\n    width: 60%;\n  }\n}\n\n/* Laptop / Small Desktop - 1024px to 1439px */\n@media (max-width: 1439px) {\n  .upskld_student_banner_pg_gif {\n    width: 68%;\n  }\n}\n\n/* iPad Pro / Large Tablets (landscape) - 1024px */\n@media (max-width: 1024px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 70vh;\n  }\n\n  .upskld_student_banner_pg_gif {\n    width: 80%;\n  }\n}\n\n/* iPad / Android Tablets (portrait & landscape) - 768px to 1023px */\n@media (max-width: 768px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 60vh;\n  }\n\n  .upskld_student_banner_pg_gif {\n    width: 90%;\n  }\n}\n\n/* Large Phones / Small Tablets (landscape phones) - 600px to 767px */\n@media (max-width: 600px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 50vh;\n  }\n\n  .upskld_student_banner_pg_gif {\n    width: 100%;\n  }\n}\n\n/* Mobile responsive - iPhone Pro Max, Android large - 480px */\n@media (max-width: 480px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 42vh;\n  }\n\n  .upskld_student_banner_pg_gif {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    display: block;\n  }\n}\n\n/* Standard Phones - iPhone 12/13/14, Android mid - 390px to 479px */\n@media (max-width: 390px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 45vh;\n  }\n}\n\n/* Small Phones - iPhone SE, older Android - 360px */\n@media (max-width: 360px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 50vh;\n  }\n}\n\n/* Extra Small Phones - 320px (iPhone 5/SE 1st gen) */\n@media (max-width: 320px) {\n  .upskld_student_banner_pg_wrapper {\n    height: 55vh;\n  }\n}\n\n/* Landscape orientation - phones/tablets rotated */\n@media (max-height: 480px) and (orientation: landscape) {\n  .upskld_student_banner_pg_wrapper {\n    height: 100vh;\n  }\n\n  .upskld_student_banner_pg_gif {\n    width: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
